import Vue from 'vue';

const errors = {
  '404': {
    headline: '404 Not found',
    text: 'Page does not exist'
  },
  '401': {
    headline: '401 Unauthorized',
    text: 'The preview site is only available to invited users'
  }
};

function getError(status, screenSize) {
  let error = errors[status];
  if(!error) {
    error = {
      headline: '400',
      text: 'Bad request'
    };
  }

  const errorPage = {
    large: [
      {
        scrolledSection: {
          sectionType: 'text',
          data: error
        },
      }
    ],
  };

  return errorPage[screenSize];
}

function getRemotePage(language, name, invite, screenSize) {
  return Vue.http.get(`/api/pages/${language.code}/${screenSize}/${name}`, { params: { invite } })
    .then(response => response.body)
    .catch(response => getError(response.status, screenSize, language));
}

export default function(language, name, inviteToken, screenSize) {
  return Promise.resolve(getRemotePage(language, name, inviteToken, screenSize));
}



// WEBPACK FOOTER //
// ./pageLoader.js